
/** @format */

import React from 'react';
import { Grid, Collapse, CircularProgress, Button } from '@mui/material';
import { useStyles } from '../style';
import { useNavigate } from 'react-router-dom';
import TextItemDotted from '../../../components/TextItemDotted';

const CheckCollateral = (props) => {
  const classes = useStyles();
  const { result } = props;
  const navigate = useNavigate();

  return (
    <>
      {result ? (
        <Grid container direction="row" alignItems="center" spacing={0} item xs={12}>

          {/* وضعیت  با موفقیت  */}
          {result?.source?.warrantyStep !== 'REGISTER_COLLATERAL' &&
            result?.source?.warrantyStep !== 'COLLATERAL_INQUIRY' ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات و وضعیت بررسی وثیقه</h3>
              </Grid>

              {
                <>
                  <TextItemDotted title=" شماره چک  " title2={result?.source?.chequeInquiry?.sayadId} />
                  <TextItemDotted title=" تاریخ استعلام   " isDate={true} title2={result?.source?.chequeInquiry?.inquiryDate} />
                </>
              }
              <Grid className={classes.blockCardFooter}>
                <h3 className={classes.blockCardFooterTitle}> بررسی وثیقه با موفقیت انجام شد.</h3>
              </Grid>
            </Grid>
          ) : (
            ''
          )}

          {/* وضعیت  منقضی شده   */}
          {(result?.source?.warrantyStep === 'REGISTER_COLLATERAL' &&
            result?.source?.warrantyStep === 'COLLATERAL_INQUIRY') && result?.source?.warrantyStatus === 'EXPIRED' ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات و وضعیت بررسی وثیقه</h3>
              </Grid>
              {
                <>
                  <TextItemDotted title=" شماره چک " title2={result?.source?.chequeInquiry?.sayadId || 'در انتظار ثبت'} />
                  <TextItemDotted title=" تاریخ استعلام   " isDate={true} title2={result?.source?.chequeInquiry?.inquiryDate} />

                </>
              }

              <Grid className={classes.blockCardFooter}>
                <h3 className={classes.blockCardFooterTitle}>
                  درخواست صدور ضمانت نامه منقضی شده است
                </h3>
              </Grid>
            </Grid>
          ) : (
            ''
          )}

          {/* وضعیت  در انتظار   */}
          {(result?.source?.warrantyStep === 'REGISTER_COLLATERAL' ||
            result?.source?.warrantyStep === 'COLLATERAL_INQUIRY') &&
            result?.source?.warrantyStatus === 'WAITING' ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات و وضعیت بررسی وثیقه</h3>
              </Grid>

              {
                <>
                  <TextItemDotted title=" شماره چک " title2={result?.source?.chequeInquiry?.sayadId || 'در انتظار ثبت'} />

                </>
              }
              <Grid className={result?.source?.warrantyStep === 'REGISTER_COLLATERAL' ? classes.blockCardFooterHasBtn : classes.blockCardFooter}>
                {result?.source?.warrantyStep === 'REGISTER_COLLATERAL' && (
                  <>
                    <h3 className={classes.blockCardFooterTitle}> در انتظار بارگذاری وثیقه</h3>
                    <Button
                      color="primary"
                      className={classes.continueBtn}
                      variant="contained"
                      onClick={() => navigate('/Warranty/Request')}
                    >
                      ادامه فرایند
                    </Button>
                  </>
                )}
                {result?.source?.warrantyStep === 'COLLATERAL_INQUIRY' && (
                  <h3 className={classes.blockCardFooterTitle}>
                    اطلاعات شما در حال بررسی می باشد.
                  </h3>
                )}
              </Grid>
            </Grid>
          ) : (
            ''
          )}

          {/* وضعیت  رد شده    */}
          {((result?.source?.warrantyStep === 'REGISTER_COLLATERAL' ||
            result?.source?.warrantyStep === 'COLLATERAL_INQUIRY'
          ) &&
            (result?.source?.warrantyStatus === 'INCOMPLETE' ||
              result?.source?.warrantyStatus === 'REJECTED')) ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات و وضعیت بررسی وثیقه</h3>
              </Grid>

              {
                <>
                  <TextItemDotted title=" شماره چک  " title2={result?.source?.chequeInquiry?.sayadId} />
                  <TextItemDotted
                    title="دلیل رد وثیقه "
                    title2=''
                    type="desc"
                  />
                  <TextItemDotted
                    title=""
                    title2={result?.source?.chequeInquiry?.inquiryDescription}
                    type="desc"
                  />
                </>
              }
              <Grid className={classes.blockCardFooterHasBtn}>
                <h3 className={classes.blockCardFooterTitle}> بررسی وثیقه رد شد .</h3>
                <Button
                  color="primary"
                  className={classes.continueBtn}
                  variant="contained"
                  onClick={() => navigate('/Warranty/Request')}
                >
                  ادامه فرایند
                </Button>
              </Grid>
            </Grid>
          ) : (
            ''
          )}

   

          {/* وضعیت  لغو شده   */}
          {(result?.source?.warrantyStep === 'REGISTER_COLLATERAL' ||
            result?.source?.warrantyStep === 'COLLATERAL_INQUIRY'
          ) &&
            (result?.source?.warrantyStatus === 'CANCELED') ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات و وضعیت بررسی وثیقه</h3>
              </Grid>

              {
                <>

                </>
              }
              <Grid className={classes.blockCardFooter}>
                <h3 className={classes.blockCardFooterTitle}> درخواست توسط ضمانت‌خواه لغو شده است.</h3>

              </Grid>
            </Grid>
          ) : (
            ''

          )}
        </Grid>
      ) : (
        result?.length !== 0 ? (
          <div className={classes.loadingFinger}>
            <CircularProgress color="inherit" size={30} />
          </div>
        ) : (
          ''
        )
      )}
    </>
  );
};

export default CheckCollateral;
